
// Public user system imports
import {
  RegistrationForm,
  LoginForm,
  GoogleLoginButton,
  ProfileUpdateForm,
  NotificationPanelContainer,
  PasswordResetForm,
  PasswordResetConfirmForm,
  PublicPage
} from "./publicuser";
import { Route, Routes, useLocation } from "react-router-dom";

import Navbar from "./components/Navbar";
import ProtectedRoute from "./components/ProtectedRoute";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import ScrollToTopButton from "./components/ScrollToTopButton";
import PublicProtectedRoute from "./components/PublicProtectedRoute";
import { GlobalDataProvider } from "./context/GlobalDataContext";

import Home from "./component02/Home";
import JobTablePage from "./component02/JobTablePage";
import ResultTablePage from "./component02/ResultTablePage";
import AdmitCardTablePage from "./component02/AdmitCardTablePage";
import AnswerKeyTablePage from "./component02/AnswerKeyTablePage";
import SyllabusTablePage from "./component02/SyllabusTablePage";
import AdmissionTablePage from "./component02/AdmissionTablePage";
// import HeadTableByJobPage removed
import SelectionJobPage from "./component02/SelectionJobPage";
import PrivacyPolicyPage from "./component02/PrivacyPolicyPage";
import TermsOfServicePage from "./component02/TermsOfServicePage";
import AboutPage from "./component02/AboutPage";
import FeedbackPage from "./component02/FeedbackPage";
import Search from "./component02/Search";
import ContactPage from "./component02/ContactPage";
import FAQPage from "./component02/FAQPage";

import Login from "./pages/superadmin/Login";
import AdminPanel from "./pages/superadmin/AdminPanel";

import AdministrativeAdminPanel from "./pages/administrativepanel/AdministrativeAdminPanel";
import HrAdminPanel from "./pages/hr/HrAdminPanel";

import { ToolPage, Tool1Page, Tool2Page, Tool3Page } from "./pages/tool";


// AuthCustom imports
import HrRegister from "./pages/AuthCustom/HrRegister";
import HrLogin from "./pages/AuthCustom/HrLogin";
import AdministrativeRegister from "./pages/AuthCustom/AdministrativeRegister";
import AdministrativeLogin from "./pages/AuthCustom/AdministrativeLogin";


import GlobalSkeletonOverlay from "./components/GlobalSkeletonOverlay";

function App() {
  const location = useLocation();
  // Hide Navbar only on /admin subroutes, but show on exact /admin
  const hideNavbar = (
    (location.pathname.startsWith('/admin') && location.pathname !== '/admin') ||
    location.pathname === '/hr-login-panel' ||
    location.pathname === '/super-admin' ||
    location.pathname === '/administrative-login-panel'
  );
  // Show Navbar on administrative and HR login/register
  const showNavbar =
    location.pathname === '/administrative-login' ||
    location.pathname === '/administrative-register' ||
    location.pathname === '/hr-login' ||
    location.pathname === '/hr-register';
  return (
    <GlobalDataProvider>
      <GlobalSkeletonOverlay /> 
      <ScrollToTop />
      {(!hideNavbar || showNavbar) && <Navbar />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/jobTablePage" element={<JobTablePage/>} />
        <Route path="/resultTablePage" element={<ResultTablePage />} />
        <Route path="/admitCardTablePage" element={<AdmitCardTablePage />} />
        <Route path="/answerKeyTablePage" element={<AnswerKeyTablePage />} />
        <Route path="/syllabusTablePage" element={<SyllabusTablePage />} />

        {/* Public user system routes */}
        <Route path="/publicuser/register" element={<RegistrationForm />} />
        <Route path="/publicuser/login" element={<LoginForm />} />
        <Route path="/publicuser/google" element={<GoogleLoginButton />} />
        <Route path="/publicuser/profile" element={
          <PublicProtectedRoute>
            <ProfileUpdateForm />
          </PublicProtectedRoute>
        } />
        <Route path="/publicuser/notifications" element={<NotificationPanelContainer />} />
        <Route path="/publicuser/password-reset" element={<PasswordResetForm />} />

        <Route path="/publicuser/password-reset/confirm/:token" element={<PasswordResetConfirmForm />} />
     
        <Route path="/publicuser/publicpage/*" element={<PublicPage />} />
        <Route path="/admissionTablePage" element={<AdmissionTablePage />} />
        {/* <Route path="/headtable/:jobSlug" element={<HeadTableByJobPage />} /> */}
        <Route path="/searchPage" element={<Search />} />
        <Route path="/contactPage" element={<ContactPage />} />
        <Route path="/aboutPage" element={<AboutPage />} />
        <Route path="/feedback" element={<FeedbackPage />} />
        <Route path="/faq" element={<FAQPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
        <Route path="/terms-of-service" element={<TermsOfServicePage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/mform/:slug" element={<SelectionJobPage />} />
        <Route path="/super-admin" element={
          <ProtectedRoute allowedRoles={["superadmin"]}>
            <AdminPanel />
          </ProtectedRoute>
        } />
         <Route path="/hr-login-panel" element={
          <ProtectedRoute allowedRoles={["hr"]}>
            <HrAdminPanel />
          </ProtectedRoute>
        } />
        <Route path="/administrative-login-panel" element={
          <ProtectedRoute allowedRoles={["administrative"]}>
            <AdministrativeAdminPanel />
          </ProtectedRoute>
        } />
       
        <Route path="/tool" element={<ToolPage />} />
        <Route path="/tool/tool1" element={<Tool1Page />} />
        <Route path="/tool/tool2" element={<Tool2Page />} />
        <Route path="/tool/tool3" element={<Tool3Page />} />

        {/* HR/Administrative AuthCustom routes */}
        <Route path="/hr-register" element={<HrRegister />} />
        <Route path="/hr-login" element={<HrLogin />} />
        <Route path="/administrative-register" element={<AdministrativeRegister />} />
        <Route path="/administrative-login" element={<AdministrativeLogin />} />
      </Routes>
      <ScrollToTopButton />
      {!location.pathname.startsWith('/admin') && location.pathname !== '/hr-login-panel' && location.pathname !== '/super-admin' && location.pathname !== '/administrative-login-panel' && location.pathname !== '/hr-login' && location.pathname !== '/hr-register' && <Footer />}
    </GlobalDataProvider>
  );
}

// Wrap App with Router in index.js, not here, to allow useLocation to work
export default App;
